/**
 * About (V2) — a PIXEL-PERFECT literal clone of the production reference "content" section
 * (__reference__/realDemo/landing/components/content, Phase 11.5.7). ONE component,
 * unchanged public API; the DOM mirrors the reference `<section>` hierarchy exactly with
 * `.sbp-about*` class names, and the layout is selected purely by a `sbp-about--<layout>`
 * class (about.css). Frozen layouts map to the reference content layouts:
 *   card → "card", cardRight → "card right", cover → "cover".
 *
 * Composed from the shared production primitives (Section, Media, InfoBlock). Assets arrive
 * resolved via the Asset Resolver; theme + RTL come from the Section. The reference "content"
 * row owns its own padding (the row itself is `padding:0`), so the Section is `flush`.
 */
import type { SectionComponentProps } from '../../runtime/types'
import { Section, Media, InfoBlock } from '../shared'
import './about.css'

export function About(p: SectionComponentProps<'about'>) {
  const { content, layout, id, theme, locale, align, assets } = p

  const item = content.media?.[0]
  const asset = item ? assets.resolve(item.assetId) : null

  const titleId = content.heading ? `${id}-title` : undefined
  const infoAlign = align ?? 'start'

  return (
    <Section
      as="section"
      theme={theme}
      locale={locale}
      id={id}
      flush
      ariaLabelledBy={titleId}
      className={`sbp-about sbp-about--${layout}`}
    >
      {item && (
        <div className="sbp-about__media">
          <Media asset={asset} kind={item.type} alt={content.heading} />
        </div>
      )}
      <div className="sbp-about__info">
        <div className="sbp-about__info-content">
          <InfoBlock
            headingLevel={2}
            heading={content.heading}
            subheading={content.subheading}
            actions={content.actions}
            headingId={titleId}
            align={infoAlign}
          />
        </div>
      </div>
    </Section>
  )
}
